<template>
    <div v-if="show_alert">    
        <teleport to="body">
            <div class="alert-frame" :class="{'error-style': isError, 'validation-style': !isError}">
                <div class="icon">
                    <span class="material-symbols-outlined"  v-if="isError">cancel</span>
                    <span class="material-symbols-outlined" v-else>check_circle</span>
                </div>
                <div>{{ msg }}</div>
            </div>
        </teleport>
    </div>
</template>

<script>
export default {
    props: ['msg', 'isError'],
    data() {
        return {
            show_alert: false,
        }
    },
    watch: {
        msg() {
            if (this.msg != "") {
                this.show_alert = true
                setTimeout(()=> {
                    this.show_alert = false
                    if (this.isError) {
                        this.$store.commit("changeErrorMsg", "")
                    } else {
                        this.$store.commit("changeValidationMsg", "")
                    }
                }, 4000);
            }
        }
    }
}
</script>

<style>
.alert-frame {
    z-index: 10000;
    min-width: 250px;
    padding: 5px;
    position: fixed;
    top: 100px;
    right: 20px;
    text-align: right;
    border-radius: 5px;
    font-size: 16px;
    display: flex;
    align-items: center;
    color: #1C1C1E;
    border: 1px solid lightgrey;
    background-color: white;
}
.alert-frame .icon span {
    font-size: 45px;
}

.validation-style  .material-symbols-outlined {
    color: green;
}
.error-style  .material-symbols-outlined {
    color: rgb(154, 2, 2);
}

@keyframes slideInFromRight {
  from {
    transform: translateX(100%); /* Commencer depuis la droite de l'écran */
    opacity: 0; /* Commencer avec un élément complètement transparent */
  }
  to {
    transform: translateX(0); /* Terminer à sa position normale */
    opacity: 1; /* Terminer avec un élément complètement opaque */
  }
}

/* Appliquer l'animation à .alert-frame */
.alert-frame {
  animation: slideInFromRight 0.5s ease-out forwards; /* Nom de l'animation, durée, fonction d'accélération, et 'forwards' pour garder l'état final */
}
</style>